const vi = {
  male: 'Nam',
  female: 'Nữ',
  gender: 'Giới tính',
  dob: 'Ngày sinh',
  phone: 'Số điện thoại',
  notification: 'Thông báo',
  session_expired_message:
    'Hết phiên đăng nhập. Bạn vui lòng đăng nhập lại để tiếp tục sử dụng dịch vụ',
  ok: 'Đồng ý',
  close: 'Đóng',
  cancel: 'Huỷ',
  contact_now: 'Liên hệ ngay',
  later: 'Để sau',
  hotline: '02422298888',
  hotline2: '02473099866',
  general_error: 'Rất tiếc! Đã xảy ra lỗi. Vui lòng thử lại',
  no_internet:
    'Thiết bị của Quý khách đang ngoại tuyến. Vui lòng kiểm tra kết nối internet và thử lại',
  feature_in_development: 'Chức năng đang trong quá trình phát triển',
  detail: 'Chi tiết',
  common_no_data_display: 'Không có dữ liệu để hiển thị',
  common_month: 'Tháng',
  reset: 'Đặt lại',
  money_unit: 'VND',
  here: 'TẠI ĐÂY',
  apply: 'Áp dụng',
  loading_data: 'Đang tải dữ liệu ...',
  loading_data_without_dot: 'Đang tải dữ liệu',
  error_please_contact:
    '<strong>Rất tiếc đã xảy ra lỗi!</strong> <br/><br/> Chúng tôi đang tìm cách khắc phục.<br/> Vui lòng liên hệ hotline ',
  benefit_short: 'QL',
  insurance: 'bảo hiểm',
  contact_hotline: 'Liên hệ Hotline',
  hotline1: '024 7309 9866',
  call_now: 'Gọi ngay',
  buy_insurance_online: 'Mua bảo hiểm Online',
  logo: 'Bảo hiểm MB Life',
  companion_step_firmly_safety: `Đồng Hành Vững Bước <br/> An Tâm Bảo Vệ`,
  companion_with_you_to_build_happy: 'Đồng hành cùng bạn dựng xây hạnh phúc',
  join_insurance: 'Tham gia bảo hiểm',
  join_with_us_to_get_protect_and_happy:
    'Tham gia ngay với chúng tôi để đảm bảo sự thịnh vượng an toàn và cuộc sống hạnh phúc bên gia đình bạn',
  view_detail: 'Xem chi tiết',
  commitment_when_buy_online_insurance:
    '<strong>Cam Kết</strong> Khi Mua <br/> Bảo Hiểm Trực Tuyến',
  auto_100: '<strong>100% Online</strong> tự động',
  three_health_question: '<strong>3 câu hỏi</strong> sức khỏe ngắn',
  three_minute_to_buy: '<strong>3 phút</strong> để mua hợp đồng',
  five_to_teen_minutes_to_get_protect:
    '<strong>5-10 phút</strong> để được bảo vệ',
  hot_sales_products: 'Sản phẩm bán chạy',
  top_products:
    'Các sản phẩm hàng đầu được khách hàng lựa chọn và tin dùng tại MB Life ',
  mbal_core_value:
    'Với MB Life, chúng tôi không ngừng tìm kiếm cơ hội để quan tâm và bảo vệ sức khỏe của mỗi người Việt Nam',
  customer_story: 'CÂU CHUYỆN KHÁCH HÀNG',
  contact: 'Liên hệ',
  mbal_address:
    'Tầng 15, Tòa nhà MB - Số 21 Cát Linh, Phường Ô Chợ Dừa, Thành phố Hà Nội',
  mbal_email: 'dvkh@mblife.vn',
  mbal_phone: '024 7309 9866',
  follow_mbal: 'Theo dõi MB Life',
  copy_right: '© 2022 MB Life.All rights reserved.',
  view_more: 'Xem thêm',
  collapse: 'Thu gọn',
  insuranceContractNumber:"Số Hợp đồng bảo hiểm/ Hồ sơ yêu cầu bảo hiểm",
  enterInsuranceContractNumber:"Nhập số Hợp đồng bảo hiểm/ số Hồ sơ yêu cầu bảo hiểm",
  dateBuyInsurance:"Ngày sinh Bên mua bảo hiểm",
  dateUseInsurance:"Ngày sinh Người được bảo hiểm",
  selectTypeDocument:"Chọn loại giấy tờ tuỳ thân",
  placehoderSelectTypeDocument:"Lựa chọn loại giấy tờ tùy thân",
  documentPerson:"Số giấy tờ tùy thân",
  placeholderDocumentPerson:"Nhập số giấy tờ tùy thân",
  bornPeopleBuyInsurance:"Ngày sinh Bên mua bảo hiểm",
  bornPeopleUseInsurance:"Ngày sinh Người được bảo hiểm",
  ms001:"Truy vấn không thành công. Hotline: 024 2229 8888",
  deleteTokenCard : "Bạn có muốn xóa không?"
};

export default vi;
